import './App.css';
import ProductPage from './ProductPage';
import SuccessPage from './SuccessPage';
import BusinessSuccessPage from './BusinessSuccessPage';
import PasscodeGate from './PasscodeGate';
import { useEffect } from 'react';
import { initGA, trackPageView } from './GoogleAnalytics';
import { initConversionTracking } from './ConversionTracking';
import ComingSoon from './ComingSoon';

function App() {
  // Initialize Google Analytics + ad conversion tracking (Google Ads / Meta Pixel).
  // Conversion tracking is a no-op until the ad IDs are set in env, so this is safe now.
  useEffect(() => {
    initGA();
    initConversionTracking();
    trackPageView(window.location.pathname + window.location.search, document.title);
  }, []);

  // Simple routing based on URL path
  const path = window.location.pathname;

  if (path === '/coming-soon') {
    return <ComingSoon onPasscodeSubmit={() => {}} />;
  }
  if (path === '/success') {
    return <SuccessPage />;
  }

  // Business routes still require the passcode gate
  if (path === '/biz') {
    return (
      <PasscodeGate>
        <ProductPage isBiz={true} />
      </PasscodeGate>
    );
  }

  if (path === '/biz-success') {
    return (
      <PasscodeGate>
        <BusinessSuccessPage />
      </PasscodeGate>
    );
  }

  // /business is not a real route. Without this guard it falls through to the
  // default below and renders the REGULAR (Stripe-checkout) order page, which
  // wrongly lets a "business" URL place a paid retail order. Send it to /biz.
  if (path === '/business' || path === '/business/') {
    window.location.replace('/biz');
    return null;
  }

  // Regular customer order pages — no passcode
  return <ProductPage />;
}

export default App;
